export default __webpack_public_path__ + "static/media/classes.866b7077.svg";